<template>
  <Waypoint @change="onChange" class="slide" :id="this.id">
    <div
      class="slide-bg"
      :style="`background-image: url(${this.imageArray[0]});`"
    ></div>

    <div class="card-wrapper" :class="{ active: getActiveInfo == this.id }">
      <div class="card-header">
        <h2 class="card-title">{{ this.data.collection }}</h2>
        <button
          class="card-info-button"
          @click="
            getActiveInfo === this.id
              ? activeInfoAction(null)
              : activeInfoAction(this.id);
            track('Info button - ' + this.data.collection);
          "
          :class="{ active: getActiveInfo == this.id }"
        >
          <span>Info</span>
          <span>{{ this.close }}</span>
        </button>
      </div>

      <div
        v-if="this.imageArray.length === 1"
        class="card-image"
        :class="this.data.imageContain === 'TRUE' ? 'contain' : null"
        :style="`background-image: url(${this.imageArray[0]});`"
      ></div>
      <div v-else class="slider">
        <div
          v-for="(image, index) in this.imageArray"
          :key="index"
          :style="`background-image: url(${image});`"
          class="card-image slider-slide"
        ></div>
      </div>

      <div class="card-text">
        <p>{{ this.summaryText }}</p>
        <a
          :href="this.data.link"
          target="_blank"
          class="card-text-collection-link"
          @click="track('Link (in list card) - ' + this.data.link)"
          >{{ this.viewCollection }} <i class="fas fa-external-link-alt"></i
        ></a>
      </div>
      <a
        class="card-collection-link"
        target="_blank"
        :href="this.data.link"
        @click="track('Link (under card) - ' + this.data.link)"
        >{{ this.viewCollection }} <i class="fas fa-external-link-alt"></i
      ></a>
    </div>
  </Waypoint>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import { Waypoint } from "vue-waypoint";

const apiKey = "kfcyaqmetx72h2vnc6nn8x2b";
const imagefolder = document
  .querySelector("#app")
  .getAttribute("data-imagefolder");

export default {
  name: "Card",
  components: {
    Waypoint,
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    lang: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      imageArray: [],
    };
  },
  computed: {
    ...mapGetters(["getActiveCard", "getActiveInfo", "getLanguage"]),
    close() {
      switch (this.lang) {
        case "en":
          return "Close";
          break;
        case "fr":
          return "Fermer";
          break;
        case "es":
          return "Cerrar";
          break;
        case "de":
          return "Schließen";
          break;
        case "it":
          return "Chiudi";
          break;
        case "pt":
          return "Fechar";
          break;
        case "nl":
          return "Sluiten";
          break;
        case "jp":
          return "閉じる";
          break;
      }
    },
    viewCollection() {
      switch (this.lang) {
        case "en":
          return "View collection";
          break;
        case "fr":
          return "Voir la collection";
          break;
        case "es":
          return "Ver la colección";
          break;
        case "de":
          return "Kollektion anzeigen";
          break;
        case "it":
          return "Guarda la collezione";
          break;
        case "pt":
          return "Ver a coleção";
          break;
        case "nl":
          return "Bekijk de collectie";
          break;
        case "jp":
          return "コレクションの例を見る";
          break;
      }
    },
    summaryText() {
      switch (this.lang) {
        case "en":
          return this.data.summary.en;
          break;
        case "fr":
          return this.data.summary.fr;
          break;
        case "es":
          return this.data.summary.es;
          break;
        case "de":
          return this.data.summary.de;
          break;
        case "it":
          return this.data.summary.it;
          break;
        case "pt":
          return this.data.summary.pt;
          break;
        case "nl":
          return this.data.summary.nl;
          break;
        case "jp":
          return this.data.summary.jp;
          break;
      }
    },
  },
  methods: {
    ...mapActions(["activeCardAction", "activeInfoAction"]),
    getImage() {
      //split by pipe to see if there is more than one image
      let split = this.data.image.split(" | ");

      //loop through each image and get image type and name
      split.forEach((item) => {
        let imageType = item.split(":")[0];
        let imagePath = item.substring(item.indexOf(":") + 2, item.length);

        //use API if editorial, or get path if ownimage
        switch (imageType) {
          case "editorial":
            let imageURL =
              "https://api.gettyimages.com/v3/search/images/editorial?phrase=" +
              imagePath +
              "&fields=high_res_comp";

            axios
              .get(imageURL, {
                headers: {
                  "Api-Key": apiKey,
                },
              })
              .then((response) => {
                this.imageArray.push(
                  response.data.images[0].display_sizes[0].uri
                );
              });
            break;
          case "ownimage":
            this.imageArray.push(imagefolder + imagePath);
            break;
        }
      });
    },
    onChange(waypointState) {
      if (waypointState.going === "IN") {
        this.activeCardAction(this.id);
      }
      if (waypointState.going === "OUT") {
        this.activeInfoAction(null);
      }
    },
    track(what) {
      this.$gtag.event("Click events", {
        event_label: what,
      });
    },
  },
  mounted() {
    this.getImage();
    // console.log(this.image);
  },
};
</script>

<style scoped>
</style>